// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import ExportingZipAlertToast from './ExportingZipAlertToast';

// Actions
import { triggerDownload } from '../../element/attachments/attachmentDownloadActions';
import { boardExportReset } from '../../../common/export/exportActions';

// Selectors
import { getBoardExports } from './exportSelector';

// Utils
import { getSessionId } from '../../device/deviceSessionService';

const mapStateToProps = createStructuredSelector({
    boardExports: getBoardExports,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchTriggerDownload: (args) => dispatch(triggerDownload(args)),
    dispatchBoardExportReset: (args) => dispatch(boardExportReset(args)),
});

const ExportingZipContainer = (props) => {
    const { boardExports, dispatchTriggerDownload, currentBoardId, dispatchBoardExportReset } = props;

    const currentSessionId = getSessionId();

    useEffect(() => {
        boardExports.map((item) => {
            if (currentSessionId === item.get('sessionId'))
                dispatchTriggerDownload({
                    url: item.get('downloadUrl'),
                    filename: item.get('fileName'),
                    id: currentBoardId,
                });
            dispatchBoardExportReset({ boardId: currentBoardId });
        });
    }, [boardExports]);

    return <ExportingZipAlertToast {...props} />;
};

ExportingZipContainer.propTypes = {
    boardExports: PropTypes.object,
    currentBoardId: PropTypes.string,
    currentSessionId: PropTypes.string,

    dispatchTriggerDownload: PropTypes.func,
    dispatchBoardExportReset: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportingZipContainer);
